import ClassNames from "classnames";
import { FunctionComponent } from "react";
import styles from "../../stylesheets/components/quote-icon.module.css";
import { ColorScheme, MediaAlign, QuoteLayout } from "../../types/index.js";
import { css } from "../../utils/emotion.js";
import Icon from "../Icon.js";

interface Props {
  type: "open" | "close";
  layout: QuoteLayout;
  scheme: ColorScheme;
  mediaAlign: MediaAlign;
}

const QuoteIcon: FunctionComponent<Props> = ({
  type,
  layout,
  scheme,
  mediaAlign,
}) =>
  layout === "layout-3" ? null : (
    <div
      className={ClassNames(
        styles.QuoteModule__IconContainer,
        styles[`QuoteModule--${layout}`],
        styles[`QuoteModule__IconContainer--media-${mediaAlign}`],
      )}
    >
      <Icon
        glyph={type === "open" ? "quotes-open" : "quotes-close"}
        className={ClassNames(
          styles.QuoteModule__Icon,
          styles[`QuoteModule__Icon--${type}`],
          layout === "layout-2" &&
            css({ backgroundColor: scheme.main.background }),
        )}
      />
    </div>
  );

export default QuoteIcon;
